<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <v-row no-gutters class="align-baseline">
        <v-col cols="1">
          <v-badge :color="productColour">
            <span slot="badge">{{ product.score }}</span>
          </v-badge>
        </v-col>
        <v-col>
          <div class="v-list-item__title">{{ titleText }}</div>
          <div class="v-list-item__subtitle grey--text">{{ subtitle }}</div>
          <v-alert v-if="hasErrors" dense outlined type="error" class="mt-4 mb-0">
            This enquiry has errors, please correct the answers, if necessary, before resending
          </v-alert>
        </v-col>
        <v-col cols="3" class="text-sm-center">
          <v-btn
            v-if="hasErrors"
            :disabled="disableButton"
            :color="productColour"
            @click.native.stop="reSendEnquiry(enquiry.id)"
          >
            Re-send
          </v-btn>
          <v-btn v-else :disabled="disableButton" text :color="productColour" @click.native.stop="makeEnquiry(product)">
            Make Enquiry
          </v-btn>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <product-list-content :product-id="product.id" :colour="productColour" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import ProductListContent from '@/components/Platform/Customers/OverviewDrawer/Products/ProductListContent';

export default {
  name: 'product-list-item',
  components: { ProductListContent },
  props: ['product', 'enquiries'],
  data: () => ({
    disableButton: false
  }),
  computed: {
    ...mapGetters(['UserHasRole']),
    productColour() {
      return _.eq(this.product.colour, 'amber') ? 'orange darken-2' : this.product.colour;
    },
    subtitle() {
      return this.UserHasRole('Broker') ? `${this.product.product_type} - 2.5% commission` : this.product.product_type;
    },
    titleText() {
      const showTier = !this.UserHasRole('Broker');
      return this.product.name + (this.product.tier_order > 0 && showTier ? ` (Tier ${this.product.tier_order})` : '');
    },
    hasErrors() {
      return (
        _.filter(
          this.enquiries,
          enquiry => enquiry.product.id === this.product.id && _.get(enquiry, 'feedback.errors', null) !== null
        ).length > 0
      );
    },
    enquiry() {
      return _.find(this.enquiries, enquiry => enquiry.product.id === this.product.id);
    }
  },
  methods: {
    ...mapActions(['makeCustomerEnquiry', 'reSendCustomerEnquiry']),
    makeEnquiry: function(product) {
      this.disableButton = true;
      this.makeCustomerEnquiry(product);
    },
    reSendEnquiry: function(enquiryId) {
      this.disableButton = true;
      this.reSendCustomerEnquiry(enquiryId);
    }
  }
};
</script>
